import React, { useEffect, useState } from 'react';
import { Check, Plus, Circle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';

const PricingCard = ({
  id,
  title,
  price,
  oldPrice,
  period,
  isPopular = false,
  features,
  unavailableFeatures = [],
  buttonText,
  buttonColor = 'btn-danger',
  billingType,
  onChoose,
  bgColor = 'white',
  tariffCheck = null
}) => {
  const { t } = useTranslation();
  const [animate, setAnimate] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timeout = setTimeout(() => setAnimate(false), 500);
    return () => clearTimeout(timeout);
  }, [billingType]);

  const handleConfirm = () => {
    setShowConfirm(false);
    onChoose?.({ tariffId: id, billingType });
  };

  return (
    <div
      style={{
        background: isPopular
          ? 'linear-gradient(135deg, #e6ffe9, #c3f8d1)'
          : bgColor,
        boxShadow: isPopular
          ? '0 0 20px rgba(0, 200, 151, 0.4)'
          : '0 1px 3px rgba(0,0,0,0.1)',
        border: isPopular ? '2px solid #00c897' : '1px solid #dee2e6',
        borderRadius: '1rem',
        padding: '1.5rem',
        position: 'relative',
        overflow: isPopular ? 'visible' : 'hidden',
        zIndex: 1
      }}
      className="h-100"
    >
      {/* Pul effektlari */}
      {/* {isPopular && (
        <div className="falling-cash-overlay">
          {[...Array(25)].map((_, i) => (
    <div
      key={i}
      className="falling-cash"
      style={{
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`
      }}
    >
      {['💲', '€', '£', '₽', '¥'][Math.floor(Math.random() * 5)]}
    </div>
  ))}
        </div>
      )} */}

      {/* Badge */}
      {isPopular && (
        <div
          className="position-absolute"
          style={{ top: '-18px', left: '50%', transform: 'translateX(-50%)', zIndex: 2 }}
        >
          <span
            className="badge shadow"
            style={{
              padding: '6px 18px',
              background: 'linear-gradient(90deg, #00c897, #1D976C)',
              color: 'white',
              fontWeight: 700,
              borderRadius: '999px',
              fontSize: '0.9rem',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              boxShadow: '0 0 12px rgba(0, 200, 151, 0.7)',
              animation: 'popScale 1.8s ease-in-out infinite alternate'
            }}
          >
            💰 {t('CURRENT_TARIFF') || 'Sizning tarifingiz'}
          </span>
        </div>
      )}

      <div className="text-center mb-4">
        <h3 className="h5 fw-bold mb-2">{title}</h3>
        <div className="d-grid justify-content-center align-items-center mb-2">
          {oldPrice && (
            <span className="text-muted" style={{ textDecoration: 'line-through', fontSize: '0.9rem' }}>
              {oldPrice}
            </span>
          )}
          <div className={`d-flex align-items-center ${animate ? 'animate-new-price' : ''}`}>
            <span className="h3 fw-bold text-dark">{price}</span>
            <span className="text-muted ms-2">{period}</span>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <p className="text-muted small mb-3">
          {title === 'Premium' && t('INCLUDES_STANDARD_AND_START')}
          {title === 'Standart' && t('INCLUDES_START')}
        </p>
        <ul className="list-unstyled">
          {features.map((feature, index) => (
            <li key={index} className="d-flex align-items-start mb-2" style={{ zIndex: 33333 }}>
              <div className="me-2">
                {feature.type === 'plus' ? <Plus size={18} className="text-success" /> : <span>{feature.type}</span>}
              </div>
              <span className="text-dark small">{feature.text}</span>
            </li>
          ))}
          {unavailableFeatures.map((feature, index) => (
            <li key={`unavailable-${index}`} className="d-flex align-items-start mb-2 text-muted">
              <div className="me-2">
                <Circle size={18} className="text-secondary" />
              </div>
              <span className="small">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      {tariffCheck && !tariffCheck.sufficient && (
        <div className="alert alert-danger py-2 px-3 mb-2" style={{ fontSize: '0.82rem', borderRadius: '0.5rem' }}>
          <strong>{t('INSUFFICIENT_BALANCE')}</strong><br />
          {t('TARIFF_UPGRADE_NEED')}: <strong>{tariffCheck.amountNeeded.toLocaleString()}</strong>
        </div>
      )}

      {buttonText && (
        <button
          className={`w-100 px-4 py-2 rounded-lg font-semibold text-white transition-all duration-300 transform hover:scale-105 hover:shadow-lg ${buttonColor}`}
          style={{
            background: tariffCheck && !tariffCheck.sufficient
              ? '#adb5bd'
              : 'linear-gradient(135deg, #28a745, #3ddc84)',
            border: 'none',
            cursor: tariffCheck && !tariffCheck.sufficient ? 'not-allowed' : 'pointer',
            opacity: tariffCheck && !tariffCheck.sufficient ? 0.7 : 1
          }}
          disabled={tariffCheck != null && !tariffCheck.sufficient}
          title={tariffCheck && !tariffCheck.sufficient ? t('INSUFFICIENT_BALANCE') : ''}
          onClick={() => { if (!(tariffCheck && !tariffCheck.sufficient)) setShowConfirm(true); }}
        >
          {buttonText}
        </button>
      )}

      <Modal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        centered
        dialogClassName="modal-gray-border confirm-modal"
        backdrop={true}
        style={{ zIndex: 9999999 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('CONFIRM_TITLE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('CONFIRM_TARIFF_CHANGE')}</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>
            {t('CANCEL')}
          </button>
          <button className="btn btn-primary" onClick={handleConfirm}>
            {t('CONFIRM')}
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes popScale {
          0% { transform: scale(1); }
          100% { transform: scale(1.08); }
        }

        .falling-cash-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }

        .falling-cash {
          position: absolute;
          top: -20px;
          font-size: 1.2rem;
          animation: cashFall 3s linear infinite;
        }

        @keyframes cashFall {
          0% {
            transform: translateY(0);
            opacity: 0.7;
          }
          100% {
            transform: translateY(400px);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  )

};

export default PricingCard;